import { ConsumptionProfile } from '@customer-apps/shared/enums';

export const DEFAULT_EXHAUST_GAS_LOSSES = 0;
export const DEFAULT_CONSUMPTION_PROFILE = ConsumptionProfile.NocturnalFall;
export const MAX_VARIANT_QUANTITY = 3;
export const CREATE_NEW_VARIANT_ID = 'CREATE_NEW_VARIANT_ID';
